import moreParty1 from "../images/moreParty1.jpeg";
import moreParty2 from "../images/moreParty2.jpeg";

const morePartyArray = () => {
  return [moreParty1, moreParty2];
};

export default morePartyArray();
